import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { ImageEditPageComponent } from "@features/image/pages/edit/image-edit-page.component";
import { SubjectTypeSuggestionState } from "@features/image/services/subject-type-suggestion.interface";
import { SubjectTypeSuggestionService } from "@features/image/services/subject-type-suggestion.service";
import { FieldWrapper } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "astrobin-solar-system-with-suggestion",
  templateUrl: "./solar-system-with-suggestion.component.html",
  styleUrls: ["./solar-system-with-suggestion.component.scss"]
})
export class SolarSystemWithSuggestionComponent extends FieldWrapper implements OnInit, OnDestroy {
  private readonly destroyed$ = new Subject<void>();
  suggestionState: SubjectTypeSuggestionState;

  constructor(
    public readonly imageEditPageComponent: ImageEditPageComponent,
    private readonly subjectTypeSuggestionService: SubjectTypeSuggestionService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    // Subscribe to the state changes
    this.subjectTypeSuggestionService.solarSystemSuggestionState$.pipe(takeUntil(this.destroyed$)).subscribe(state => {
      this.suggestionState = state;
      // Manually trigger change detection when state updates
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get showSuggestion(): boolean {
    return (
      !!this.suggestionState &&
      !this.suggestionState.dismissed &&
      !this.formControl.value &&
      this.suggestionState.status === "completed" &&
      !!this.suggestionState.suggestion &&
      !!this.suggestionState.suggestion.solarSystemMainSubject &&
      this.suggestionState.suggestion.confidence >= 0.85 &&
      !this.suggestionState.appliedSuggestion // Show suggestions 85%+ that weren't auto-applied
    );
  }

  get showAutoAppliedInfo(): boolean {
    return (
      !!this.suggestionState &&
      this.suggestionState.status === "completed" &&
      this.suggestionState.appliedSuggestion &&
      !this.suggestionState.dismissed &&
      !!this.formControl.value
    );
  }
}
